(function ($) {
    "use strict";

    var baseId = "backdrop";
    var baseClass = baseId;
    

    $.fn.extend({
        backdrop: function (options) {

            var settings = $.extend({
                text: "",
                small: false,
                animation: true,
                spinner: false,
                cssClass: ""
            }, options);

            return this.each(function() {
                //$(this).addClass("backdrop-source");

                // Get Body and add Class
                var $body = $("body");
                var $backdrop;
                var exist = false;

                if ($("#" + baseId).length) {
                    exist = true;

                    $backdrop = $("#" + baseId);
                    $backdrop.html();
                    $backdrop.attr("class", baseClass + " " + settings.cssClass);
                } else {

                    $body.addClass("backdrop-body");

                    // Create Backdrop Element
                    $backdrop = $("<div>", { id: baseId, class: baseClass }).addClass(settings.cssClass);
                    
                    // Append backdrop Element to body
                    $backdrop.appendTo($body);
                }

                if (settings.animation)
                    $backdrop.addClass("backdrop-animation");
                if (settings.small)
                    $backdrop.addClass("backdrop--small");

                // Create Wrapper
                var $wrapper = $("<div>", {
                     class: "backdrop-wrapper"
                });

                // Create Spinner and append to wrapper
                var $spinner = $("<div>", {
                    class: "spinner-container"
                }).appendTo($wrapper);

                // Problem with generating a p Element with html
                var $text = $("<p class='lead'>" + settings.text + "</p>").appendTo($wrapper);

                // Append wrapper to Backdrop Element
                $wrapper.appendTo($backdrop);


                // If should spin?
                if (settings.spinner) {
                    $spinner.spin();
                }

                // Delay for animation
                setTimeout(function () {
                    $backdrop.css("opacity", "1");
                }, 50);
            });
        },
        backdropClear: function () {
            return this.each(function () {
                $("#" + baseId).remove();
                $("body").removeClass("backdrop-body");
                $(".spinner-container").spin(false);
            });
        }
    });
})(jQuery);